import { Fn }			from "ts-base/fn";
import { Predicate }	from "ts-base/predicate";
import { Nea }			from "ts-base/nea";

/**
used instead of a validator to guarantee the original value may be branded, but not replaced
if this returns an empty array, everything is fine.
*/
export type Rejecter<T>	= Fn<T, ReadonlyArray<string>>;

export namespace Rejecter {
	export const accept	= <T>():Rejecter<T>	=>
		_it => [];

	export const predicate	= <T>(predicate:Predicate<T>, rejectionMessage:string):Rejecter<T>	=>
		it => predicate(it) ? [] : [ rejectionMessage ];

	export const concat	= <T>(a:Rejecter<T>, b:Rejecter<T>):Rejecter<T>	=>
		it => [ ...a(it), ...b(it) ];

	export const test	= <T>(self:Rejecter<T>, it:T):boolean => !Nea.is(self(it));
};
